// src/styles/common.ts
import { makeStyles } from '@material-ui/core/styles';

const useCommonStyles = makeStyles((theme) => ({
	center: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	columnCenter: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	fullWidth: {
		width: '100%',
		boxSizing: 'border-box' // 在某些指定width時將padding算進去
	},
	imgFill: {
		'& img': {
			width: '100%'
		},
	},
	imgCover: {
		width: '100%',
		height: '100%',
		objectFit: 'cover'
	},
	stampIcon: {
		position: 'absolute'
	},
	displayInMobile: {
        [theme.breakpoints.up('sm')]: {
			display: 'none !important',
		}
	},
	hideInMobile: {
        [theme.breakpoints.down('xs')]: {
			display: 'none !important'
		}
	},
	invisible: {
		visibility: 'hidden'
	}
}));

export default useCommonStyles;
